<template>
	<div>
		<h1>Gérer les aides des actions</h1>

        <b-card v-for="(help, key) in helps" :key="key">
            <h3>{{ key }}</h3>
            <b-textarea v-model="help.text"></b-textarea>
            <b-button variant="link" @click='del(key)'><i style="color:red" class="fas fa-trash"></i></b-button>
        </b-card>

        <p>Nouveau type : <input v-model="type" /> <b-button variant="link" @click="add">Ajouter</b-button></p>

        <b-button @click="save" class="mt-2">Sauvegarder</b-button>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
    
    var clone = require("clone");

	export default {
        name: "ActionsConfig",
		components: {
		},
		data: function () {
			return {
                helps: {text: ""},
                type: ""
			};
		},
		methods: {
            add()
            {
                this.helps[this.type] = {text: ""};
                this.type = "";
            },
            del(key)
            {
                var helps = clone(this.helps);
                delete helps[key];
                this.helps = helps;
            },
			async save() {
				await client.put(null, null, null, null, null, null, null, null, this.helps);

				this.$notify({
					group: "info",
					title: "Configuration des tags sauvegardé",
					type: "success",
				});
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.actions_config) {
				this.$router.push({ name: "profile" });
            }
            
            let response = await users.getSelf(true);
            this.client = response.client;
            
            if (this.client.details && this.client.details.actions && this.client.details.actions.help)
                this.helps = this.client.details.actions.help;
            else
            {
                this.helps = {}
            }
		},
	};
</script>

<style></style>
